import { useQuery } from '@tanstack/react-query';
import { dataSelector } from '@nextiva/global-store';
import { useSelector } from 'react-redux';
import { getSMSCampaignStatus } from 'services';
import { CAMPAIGN_STATUS_KEY } from '../constants';

export function useGetSMSCampaignStatus() {
  const globalStoreData = useSelector(dataSelector);
  const corpAcctNbr = globalStoreData.user?.profileDTO?.corpAcctNbr;

  return useQuery([CAMPAIGN_STATUS_KEY], {
    queryFn: () => getSMSCampaignStatus(corpAcctNbr),
    enabled: !!corpAcctNbr,
    onError: (e) => {
      // eslint-disable-next-line no-console
      console.error('Error in useGetSMSCampaignStatus', e);
    },
  });
}
